<template>
  <transition name="modal">
    <div :class="['modal', position]" v-if="openedModal">
      <div class="modal__header" v-if="closeBtn">
        <button class="modal__close" type="button" @click="close">Close</button>
      </div>
      <div class="modal__wrapper">
        <slot class="modal__form" name="body"> form </slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventsMixin } from '~/mixins/Events.js'
import { FixBody } from '~/mixins/FixBody.js'
import { EventBus } from '~/plugins/eventBus.js'

export default {
  name: 'BaseModal',
  mixins: [EventsMixin, FixBody],
  data() {
    return {
      ready: false,
    }
  },
  computed: {
    openedModal() {
      if (this.opened === true) {
        this.open()
        return true
      } else {
        return false
      }
    },
    ...mapGetters({
      vuexModalOpened: 'common/openedModal',
    }),
  },
  watch: {
    vuexModalOpened(value) {
      if (value === false) this.close()
    },
  },
  props: {
    position: {
      type: String,
      default: 'default',
    },
    closeBtn: {
      type: Boolean,
      default: true,
    },
    opened: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    open() {
      if (this.position !== 'center') {
        this.fixBody()
      }
      this.$store.commit('common/TOGGLE_MODAL', true)
    },
    close() {
      if (this.position !== 'center') {
        this.unfixBody()
      }
      this.$emit('close')
      this.$store.commit('common/TOGGLE_MODAL', false)
    },
  },
  mounted() {
    EventBus.$on('modalLoaded', () => {
      this.ready = true
    })
  },
}
</script>

<style lang="scss">
.modal {
  position: fixed;
  z-index: 999;
  top: 53px;
  right: 16px;
  left: 16px;
  max-height: 75vh;
  padding: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  transition: opacity 0.5s ease;
  overflow-y: auto;
  box-sizing: border-box;

  &.center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    width: calc(100% - 32px);

    @include media-min($tablet-width) {
      width: 450px;
    }

    &__container {
      justify-content: flex-start;
    }

    .recapcha {
      margin-bottom: 30px;
    }

    .btn {
      margin: 0 20px 0 0;

      &--mb-30 {
        margin-bottom: 30px;
      }
    }

    .modal__wrapper {
      padding-right: 16px;
    }
  }

  &__close {
    @include pseudo(15px, 15px, 'close-icon.svg');
    @include button-reset;

    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 0;
  }

  .caption {
    margin: 0 0 23px;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  .label {
    display: block;
    margin-bottom: 25px;
  }

  .field {
    display: block;
    width: 100%;
    height: 48px !important;
  }

  .btn {
    min-width: 124px;
  }

  .text {
    margin: 0 0 11px;
  }

  .link {
    $parent: &;
    color: #595d60;
    font-family: $ToyotaBook;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-decoration: underline;

    &--disabled {
      color: rgba(108, 112, 115, 0.4);
      pointer-events: none;
      cursor: not-allowed;
    }

    &:not(#{$parent}--disabled):hover {
      @include easeOut;

      color: #d90022;
    }
  }
}

@include media-min($tablet-width) {
  .modal {
    top: 50%;
    left: 50%;
    width: 344px;
    transform: translate(-50%, -50%);

    &__container {
      justify-content: flex-start;
    }

    .recapcha {
      margin-bottom: 30px;
    }

    .btn {
      margin: 0 20px 0 0;

      &--mb-30 {
        margin-bottom: 30px;
      }
    }
  }
}

@include media-min($desktop-width) {
  .modal {
    top: 20px;
    left: initial;
    right: 44px;
    width: 344px;
    transform: translate(0, 0);

    .link {
      font-size: 16px;
      line-height: 25.6px;
    }
  }
}

@include media-min($monoblock-width) {
  .modal {
    right: 360px;
  }
}

.modal-enter-active {
  transition: all 0.5s ease;
}

.modal-enter-to {
  opacity: 1;
}

.modal-leave {
  opacity: 1;
  overflow: hidden;
}

.modal-leave-active {
  transition: all 0.4s ease;
  overflow: hidden;
}

.modal-leave-to {
  opacity: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseModal.vue